code

<template>

  <div class="container">
    <div class="row fh-row justify-content-center">
      <div class="col-md-6 pl-0 pr-0 align-self-center ">
        <mdb-card class="z-depth-1 card-height">
          <mdb-card-header color="white">
            <div class="container-fluid">
              <div class="row">
                <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                  <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                  <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                  <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                </div>
              </div>
            </div>
          </mdb-card-header>
          <mdb-card-body class="text-center">
            <div class="container-fluid">
              <div class="row hh-row ">
                <div class="col-12 align-self-center">
                  <div class="row justify-content-center">
                    <div class="col-9 ">
                      <img class="logo" alt="Expired Link" src="@/assets/expired.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row mb-3">
                <div class="col">
                  <h4>{{ $store.state.expiry_message? $store.state.expiry_message: 'Uh oh. This Link Has Expired' }}</h4>
                </div>
              </div>
            </div>
          </mdb-card-body>
          <mdb-card-footer>
            <div class="container-fluid">
              <div class="row justify-content-center">
                <div class="col-md-12 mb-1 ">
                  <mdb-btn style="font-size: 15px" block color="primary" class="next-btn" size="md"
                           :disabled="!redirect_url"
                           @click="redirect">
                    Start Verification Again
                    <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                  </mdb-btn>
                </div>
              </div>
            </div>
          </mdb-card-footer>
        </mdb-card>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Expired",
    data() {
      return {
        redirect_url: null,
      };
    },
    async mounted() {
      if (this.$store.state.session_id != null) {
        let session = await this.$http.get('/sessions/' + this.$store.state.session_id);
        this.session = session.data
        this.redirect_url = this.session.client_redirect_url
      }
    },
    methods: {
      redirect() {
        window.location.href = this.redirect_url
      }
    }
  }
</script>

<style scoped lang="scss">
    @import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@600;900&display=swap");
    .font {
        font-family: 'Nunito Sans', sans-serif;
    }
    body {
        background: #f2f3f3;
        color: #666;
        text-align: center;
        font-family: 'Nunito Sans', sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        display: block;
        margin: 8px;
    }

    div.content {
        width: 660px;
        margin: 0 auto 70px;
        text-align: center;
        box-sizing: border-box;
        padding-top: 100px;
    }

    #expired-link .logo {
        width: 140px;
    }

    #logo, .logo {
        width: 100px;
        margin: 75px auto 30px auto;
    }

</style>
